import { AddUserClientRequest } from './../_models/admin/add-user-client-request.model';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { User, UserRegistration } from '../_models/index';
import { environment } from '../../environments/environment';
import { UpdateUserMfaRequiredRequest } from '../_models/admin/update-user-mfa-required-request.model';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base/base.service';
import { SessionUserHashManagerService } from './session-user-hash-manager/session-user-hash-manager.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserService extends BaseService {
  
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient, 
    private config: AppConfig,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
   }

  /**
   * The caller's current feature grants, read live from the database rather than from the copy
   * cached in localStorage at login. Used by AuthGuard on every navigation so a grant made (or
   * revoked) mid-session takes effect without the user signing out and back in.
   *
   * Deliberately NOT routed through handleError: the guard needs to distinguish "the server said
   * these are your features" from "the call failed", so that a blip falls back to the cached list
   * instead of stripping the user's whole UI. Errors are left to propagate to the caller.
   */
  getMyFeatures() {
    return this.http.get(this.apiUrl + 'api/user/MyFeatures', this.prepareOptions(null)).pipe(
      map((data: any) => data ? data.body : data)
    );
  }

  getById(id: number) {
      return this.http.get(this.apiUrl + 'api/user/GetById?id=' + id, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getById'))
    );
  }

  getByAuthenticationId(authid: string) {
    return this.http.get(this.apiUrl + 'api/user/GetUserName?authId=' + authid, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getByAuthenticationId'))
    );
  }

  register(user: User) {
      return this.http.post(this.apiUrl + 'api/user/register', user, this.prepareAnonymousOptions(user)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('register'))
    );
  }

  resetpassword(user: User) {
    return this.http.post(this.apiUrl + 'api/user/resetpassword', user, this.prepareAnonymousOptions(user)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('resetpassword'))
    );
  }

  resendActivationCode(authId: string) {
    return this.http.post(this.apiUrl + 'api/user/ResendActivationCode',{"authId": authId}, this.prepareOptions({"authId": authId})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('resendActivationCode'))
    );
  }

  sendpasswordlink(email: string) {
    return this.http.post(this.apiUrl + 'api/user/SendPassworResetLink', {"Email": email}, this.prepareOptions({"Email": email})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('sendpasswordlink'))
    );
  }

  createClientUser(user: UserRegistration) {
    return this.http.post(this.apiUrl + 'api/user/CreateClientUserAccount', user, this.prepareOptions(user)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('createClientUser'))
    );
  }

  getByRole(role: string) {
    return this.http.get(this.apiUrl + 'api/user/GetUserByRole?role=' + role, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getByRole'))
    );
  }

  resendActivationCodeByUserId(userId: number) {
    return this.http.post(this.apiUrl + 'api/user/resendActivationCodeByUserId', {"userId": userId}, this.prepareOptions({"userId": userId})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('resendActivationCodeByUserId'))
    );
  }

  disableUserAccount(guid) {
    return this.http.get(this.apiUrl + 'api/user/DisableUserAccount?guid=' + guid, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('disableUserAccount'))
    );
  }

  updateUser(user: UserRegistration) {
    return this.http.post(this.apiUrl + 'api/user/UpdateUserAccount', user, this.prepareOptions(user)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('updateUser'))
    );
  }

  updateUserMfaRequired(request: UpdateUserMfaRequiredRequest) {
    return this.http.post(this.apiUrl + 'api/user/UpdateMFARequired', request, this.prepareOptions(request)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('updateUserMfaRequired'))
    );
  }

  addNewUserClient(request: AddUserClientRequest) {
    return this.http.post(this.apiUrl + 'api/user/AddNewUserClient', request, this.prepareOptions(request)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('addNewUserClient'))
    );
  }

  validateStudentAccess(hash: string) {
    return this.http.post(this.apiUrl + 'api/user/ValidateStudentAccess'
    , {"Hash": hash}
    , this.prepareAnonymousOptions({"Hash": hash})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('validateStudentAccess'))
    );
    // , { headers: new HttpHeaders({'Content-Type': 'application/json'})});
  }


}
